import React, { useMemo} from 'react';
import styles from './Preparations.module.scss';

import { Content, Lesson } from '@types';
import { LessonType, LastVisitedLessonContentFragment } from '@api/graphql-codegen';
import SectionContents from '@src/components/program-details/lesson/lesson-section/section-contents/SectionContents';

type Props = {
  contents: Content[] | undefined;
  lesson: Lesson | undefined;
  lessonType: LessonType | undefined;
  lessonOpened: boolean;
  lastVisitedLesson?: LastVisitedLessonContentFragment;
  closeNav?: () => void;
};

function Preparations(props: Props) {
  const { contents = [], lesson, lessonOpened, lastVisitedLesson, closeNav } = props;

  const wrapperClassName = useMemo(() => {
    const classes = [styles.wrapper];
    if (lessonOpened) {
      classes.push(styles.opened);
    }

    return classes.join(' ');
  }, [lessonOpened]);
  
  return (
    <div className={wrapperClassName}>
      <div className={styles.content}>
        <SectionContents contents={contents} lesson={lesson} lastVisitedLesson={lastVisitedLesson} isPreparation closeNav={closeNav} />
      </div>
    </div>
  );
}

export default React.memo(Preparations);
